import React from 'react';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Session from '../shared/Session';
import TaskView from '../core/TaskView';
import TaskResultView from '../core/TaskResultView';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OpenApiFormGenerator from "../core/FormGenerator";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';

export default class Tasks extends React.Component<any, any> {
    timer: any = undefined;

    constructor(props: any) {
        super(props);
        this.state = {
            autoReloading: true,
            tasks: undefined,
            taskResults: undefined,
            functions: [],
            newTaskOpen: false,
            viewRecurringTasksOpen: false,
            recurringTasks: undefined
        };
        this.reloadData = this.reloadData.bind(this);
        this.handleToggleAutoReload = this.handleToggleAutoReload.bind(this);
    };

    loadRecurringTasks() {
        Session.api("GET", "/tasks/recurring", {}, (tasks: any) => {
            this.setState({
                recurringTasks: tasks
            });
        }, null, false);
    }

    reloadData() {
        Session.api("GET", "/tasks/?running=true", {}, (result: any) => {
            Session.api("GET", "/task_results/", {}, (tr_result: any) => {
                this.setState({
                    tasks: result,
                    taskResults: tr_result
                });
                let reloadIcon = document.getElementById("reloadSuccessIcon")!;
                if(!reloadIcon){
                    return;
                }
                reloadIcon.classList.add('fade-out');
                reloadIcon.style.animation = "none";
                setTimeout(function() {
                    reloadIcon.style.animation = "";
                }, 10);
                if (this.state.autoReloading) {
                    this.timer = setTimeout(this.reloadData, 1000);
                }
            }, null, false, false);
        }, null, false, false);
    }

    componentDidMount() {
        this.reloadData();
    };

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    handleToggleAutoReload(event: any) {
        if (event.target.checked) {
            this.reloadData();
        } else {
            clearTimeout(this.timer)
        }

        this.setState({
            autoReloading: event.target.checked
        })
    }

    generateShortcode() {
        var firstPart = ((Math.random() * 46656) | 0).toString(36);
        var secondPart = ((Math.random() * 46656) | 0).toString(36);
        firstPart = ("000" + firstPart).slice(-3);
        secondPart = ("000" + secondPart).slice(-3);
        return firstPart + secondPart;
    }

    render() {
        let recurringTaskElements = "";
        if (this.state.recurringTasks !== undefined) {
            recurringTaskElements = this.state.recurringTasks.map((record: any) => {
                return <TaskView key={record.id} task={record} />;
            });
        }

        let taskResultElements = "";
        if (this.state.taskResults !== undefined) {
            taskResultElements = this.state.taskResults.map((record: any) => {
                return <TaskResultView key={record.id} taskResult={record} />;
            });
        }

        let taskElements = "";
        if (this.state.tasks !== undefined) {
            taskElements = this.state.tasks.map((record: any) => {

                let log_trim = record.log.slice(0, 10).reverse();

                return <>
                    <Box key={`box-${record.id}`} display='flex' justifyContent='left' alignItems='center'>
                        <Typography key={`type-${record.id}`} variant="body1" align="left" style={{ margin: "5px 5px 5px 10px" }} gutterBottom>{record.name} {record.function} ({record.id})</Typography>
                        &nbsp;&nbsp;&nbsp;<CircularProgress key={`circle-${record.id}`} />
                    </Box>
                    <pre style={{ whiteSpace: "pre-wrap", fontSize: "10px" }}><code>
                        {log_trim}
                    </code></pre>
                    {/* Some crappy error about not being able to load the Mat UI theme context for the tooltip... */}
                    {/* <Tooltip key={`terminate-tooltip-${record.id}`} title="Terminate Task">
                        <IconButton key={`terminate-button-${record.id}`} size="small" color="inherit" style={{ margin: "3px !important" }} onClick={() => {
                            Session.api("POST", "/tasks/timeout/" + record.id, {}, null, null, true, false);
                        }}>
                            <DoDisturbIcon key={`terminate-icon-${record.id}`}/>
                        </IconButton>
                    </Tooltip> */}
                    <Button key={`terminate-button-${record.id}`} component="label" variant="contained" onClick={() => {
                        Session.api("POST", "/tasks/timeout/" + record.id, {}, null, null, true, false);
                    }}>
                        Terminate Task
                    </Button>
                    <br />
                    <br />
                </>;
            });
        }

        return (
            <>
                <Typography variant="h4" align="left" gutterBottom component="h2">
                    Tasks
                </Typography>
                <FormGroup style={{ width: "15em" }}>
                    <FormControlLabel control={
                        <>
                            <Switch
                                checked={this.state.autoReloading}
                                onChange={this.handleToggleAutoReload}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                            <CheckCircleIcon id="reloadSuccessIcon" style={{ color: "green" }} />
                        </>
                    } label="&nbsp;&nbsp;Auto-reload" />
                </FormGroup>

                <br />

                {taskElements}

                <Accordion style={{ width: this.state.newTaskOpen ? "40em" : "15em" }} expanded={this.state.newTaskOpen}>
                    <AccordionSummary
                        style={{ minHeight: "40px", height: "40px" }}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id={"panel1a-header"}
                        onClick={() => {
                            this.setState({
                                newTaskOpen: !this.state.newTaskOpen
                            });
                        }}
                    >
                        <Typography>Run a new Task</Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        style={{ padding: "2%" }}
                    >
                        <OpenApiFormGenerator
                            method={"post"}
                            path={"/tasks/"}
                            setResult={() => {
                                this.setState({
                                    newTaskOpen: false
                                });
                            }}
                        />
                    </AccordionDetails>
                </Accordion>

                <br />

                <Accordion style={{ width: this.state.viewRecurringTasksOpen ? "40em" : "15em" }} expanded={this.state.viewRecurringTasksOpen}>
                    <AccordionSummary
                        style={{ minHeight: "40px", height: "40px" }}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id={"panel1a-header"}
                        onClick={() => {
                            this.setState({
                                viewRecurringTasksOpen: !this.state.viewRecurringTasksOpen
                            });
                            this.loadRecurringTasks();
                        }}
                    >
                        <Typography>View Recurring</Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        style={{ padding: "2%" }}
                    >
                        {this.state.recurringTasks === undefined ? <CircularProgress /> :
                            recurringTaskElements
                        }
                    </AccordionDetails>
                </Accordion>
                
                <br />

                {this.state.taskResults === undefined ?
                    <>
                        <br />
                        <CircularProgress />
                    </>
                    :
                    taskResultElements
                }
            </>
        )
    }
};
